<template>
  <UIDrawer
    :is-open
    :z-index
    title="Global Search"
    direction="to-top"
    size="full"
    with-back
    flat
    class="mobile-footer-search-panel"
    @close="handleClose"
  >
    <AppGlobalSearch
      v-model:is-open="isOpen"
      v-model:search="search"
      v-model:current-tag="currentTag"
      :items-found
      :tags
      @result:click="handleClickResult"
    />
  </UIDrawer>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { ModalClass, SearchSummary } from '@types'

import { useSearchStore } from '@/store/search'

import { AppGlobalSearch } from '@app'
import { UIDrawer } from '@ui/modals'
import { useGlobalSearch } from '@/hooks/globalSearch'

type Props = {
  modal: ModalClass<any>
}

const props = defineProps<Props>()

const searchStore = useSearchStore()

const { handleSearchResult } = useGlobalSearch()

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const search = computed({
  get() {
    return searchStore.string
  },
  set(value) {
    searchStore.string = value
  },
})

const currentTag = computed({
  get() {
    return searchStore.currentTag
  },
  set(value) {
    searchStore.currentTag = value
  },
})

const tags = computed(() => searchStore.tags)

const itemsFound = computed(() =>
  searchStore.string.trim() !== '' ? searchStore.getSearchSummary : [],
)

const handleClose = () => {
  props.modal.close()
}

const handleClickResult = async (item: SearchSummary) => {
  handleClose()
  handleSearchResult(item)
}
</script>

<style>
.mobile-footer-search-panel {

  .app-global-search {
    @apply flex-auto;
    @apply overflow-hidden;

    > div > .ui-input-text {
      @apply m-2 mb-0;
    }
  }

  .app-global-search__item {
    @apply px-6;
  }
}
</style>
